import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { loginConfig } from '../utils/loginConfig.ts';

export const useAuthentication = () => {
  const { isAuthenticated, loginWithRedirect, isLoading, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const login = async () => {
      try {
        await getAccessTokenSilently();
      } catch {
        await loginWithRedirect(loginConfig(window.location.pathname));
      }
    };

    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [loginWithRedirect, isAuthenticated, isLoading, getAccessTokenSilently]);

  return { isLoading };
};
